import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { InventoryTreeVCD } from './inventory-tree/vcd/inventory-tree-vcd.component';
import { InventoryTreeVC } from './inventory-tree/vc/inventory-tree-vc.component';
import { Tabs } from '@clr/angular';
import { OrganizationService } from '../../components/compute/compute-vcd/organization/organization.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import  inventoryRouteMapper  from './inventory-route-mapper';
import { ResizeEvent } from 'angular-resizable-element';
import { AuthService } from '../../auth/auth.service';
let $ = require('jquery');

import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../refresh-shared-service';
const _ = require('lodash');

@Component({
    selector: 'inventory-main',
    providers: [
    OrganizationService
    ],
    encapsulation: ViewEncapsulation.None,
    styles: [require('./inventory.scss')],
    host: {'[class.content-container]': 'true'},
    template: require('./inventory-main.html')
})

export default class InventoryMain {
    @ViewChild(Tabs) treeTabs: Tabs;

    private computeTreeVisible: boolean = false;
    private computeTreeState: any = false;

    private networkTreeVisible: boolean = false;
    private networkTreeState: any = false;

    private computeTreeAddOrgVisible: boolean = false;
    private isAddOrgPopupVisible: boolean = false;
    private sideNavStyle: Object = {};
    private _opened: boolean = false;

    private disableCreateOrgButton = false;
    private rsService: RefreshSharedService;
    private subscription: Subscription;
    private forceReloadTree: boolean =   false;
    private isViewReady: boolean = false;

    private computeActive: boolean = false;
    private networkActive: boolean = false;

    constructor(private router: Router,
                private route: ActivatedRoute,
                public authService: AuthService,
                private rss: RefreshSharedService ) {
            this.rsService = rss;
    }

    ngOnInit() {
        this.subscription = this.rsService.getRefreshParam()
        .subscribe (
          item => {
                this.handleEmittedValues(item);
          });

        let roles = this.authService.loggedInUserInfo.roles;
        roles.forEach((role) => {
            if ( role === 'VI Administrator' ) {
                this.disableCreateOrgButton = true;
            }
        });

    }

    handleEmittedValues(item) {
        if (item.shouldReloadInventoryTree) {
            this.forceReloadTree = true;
        }
    }

    getTabIndex(url) {
        if (_.includes(url, 'inventory/networks')) {
            return 1;
        }
        return 0;
    }
    ngAfterViewInit() {
        let url = this.router.url;
        let tabIndex = this.getTabIndex(url);
        if (tabIndex === 0) {
            setTimeout(() => {
                this.computeActive = true;
                this.networkActive = false;
            }, 0);
            setTimeout(() => {
                this.computeTreeState = true;
            },0);
            setTimeout(() => {
                this.computeTreeVisible = true;
            },0);
            setTimeout(() => {
                this.computeTreeAddOrgVisible = true;
            },0);
        } else {
            setTimeout(() => {
                this.computeActive = false;
                this.networkActive = true;
            },0);
            setTimeout(() => {
                this.networkTreeState = true;
            },0);
            setTimeout(() => {
                this.networkTreeVisible = true;
            },0);
            setTimeout(() => {
                this.computeTreeAddOrgVisible = false;
            },0);
        }
        // TODO FIX
        // this.treeTabs.selectTab(this.treeTabs.tabLinks[tabIndex])
        this.isViewReady = true;
    }

    onTabSelected() {

    }

    onAddOrganization = ($event) => {
        this.isAddOrgPopupVisible = true;
    }

    onAddOrganizationClose = ($event) => {
        if ($event && $event.value) {
        this.isAddOrgPopupVisible = false;
        }
    }

    ngOnChanges(changes) {
    }
    onTabIndexChanged($event) {
        console.log ("ontab", $event)
        if (!this.isViewReady) {
            return;
        }
        if ($event === 0) {
            setTimeout(() => {
                this.computeActive = true;
                this.networkActive = false;
            }, 0);
            setTimeout(() => {
                this.computeTreeState = true;
            },0);
            setTimeout(() => {
                this.computeTreeVisible = true;
            },0);
            setTimeout(() => {
                this.computeTreeAddOrgVisible = true;
            },0);
            if (localStorage.getItem('lastComputeRoute')) {
                this.router.navigate(['/inventory/' + localStorage.getItem('lastComputeRoute')]);
            } else if (localStorage.getItem('computeRoot')) {
                this.router.navigate(['/inventory/org' + localStorage.getItem('computeRoot')]);
            }
        } else if ($event === 1) {
            setTimeout(() => {
                this.computeActive = false;
                this.networkActive = true;
            }, 0);
            setTimeout(() => {
                this.networkTreeState = true;
            },0);
            setTimeout(() => {
                this.networkTreeVisible = true;
            },0);
            setTimeout(() => {
                this.computeTreeAddOrgVisible = false;
            },0);

            if (localStorage.getItem('lastNetworkRoute')) {
                this.router.navigate(['/inventory/' + localStorage.getItem('lastNetworkRoute')]);
            } else {
                this.router.navigate(['/inventory/networks'], {relativeTo: this.route});
            }
        }
    }

    onTabContentActivated() {
        // TODO
    }

    loadDirectConnects() {
        let routePath = inventoryRouteMapper['directConnects'];
        this.router.navigate([ routePath], { relativeTo: this.route });
    }

    private _toggleSidebar() {
        this._opened = !this._opened;
    }

  onResizeEnd(event: ResizeEvent): void {
    this.sideNavStyle = {
      width: `${event.rectangle.width}px`
     };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-main.component.ts